import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Caption from "../Caption";
import styles from "./Image.css";

const maxHeight = 650; // must match what's in ./Image.css

class Image extends Component {
  render() {
    const { data } = this.props.block;
    const hasDimensions = data.orig_width && data.orig_height;
    let paddingBottom; // used for setting a correct height while we lazy load the image
    let isTall;

    if (hasDimensions) {
      let aspectRatio = data.orig_width / data.orig_height;

      // wide images
      if (aspectRatio > 1) {
        isTall = false;

        // just use the aspect ratio to set the height as a percentage
        paddingBottom = `${(1 / aspectRatio) * 100}%`;
      } else {
        isTall = true;

        // for tall images, use the raw height in pixels (pinned to maxHeight)
        paddingBottom = Math.min(maxHeight, data.orig_height);
      }
    }

    return (
      <div className={styles.root}>
        {hasDimensions ? (
          <div
            className={styles.lazyContainer}
            style={{
              paddingBottom,
              // for tall images, don't use the background color
              background: isTall ? "none" : null,
            }}
          >
            <img
              id={data.image_id}
              data-src={data.src}
              alt={data.alt_text}
              className={classNames(styles.image, "lazyload")}
            />
          </div>
        ) : (
          <div className={styles.container}>
            <img
              id={data.image_id}
              src={data.src}
              alt={data.alt_text}
              className={styles.image}
            />
          </div>
        )}
        <Caption>{this.props.children}</Caption>
      </div>
    );
  }
}

Image.propTypes = {
  block: PropTypes.object.isRequired,
};

export default Image;
